import ReactHtmlParser from 'react-html-parser';
import Output, { ListOutput } from 'editorjs-react-renderer';
import styles from './editor.module.scss';
import { motion } from 'framer-motion';

const config = {
  header: {
    disableDefaultStyle: true,
  },
  paragraph: {
    disableDefaultStyle: true,
  },
  image: {
    disableDefaultStyle: true,
  },
  list: {
    disableDefaultStyle: true,
  },
};

const headerVariants = {
  exit: {
    opacity: 0,
    y: '15%',
    transition: { duration: 0.3 },
  },
  initial: { opacity: 0, overflow: 'hidden', y: '-15%' },
  enter: { opacity: 1, y: 0, transition: { duration: 1, delay: 0.3 } },
};

const LevelHeader = ({ children, level = 2 }) => {
  switch (level) {
    case 3:
      return (
        <motion.h3
          className={styles.header}
          variants={headerVariants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <span>{children}</span>
        </motion.h3>
      );

    case 4:
      return (
        <motion.h4
          className={styles.header}
          variants={headerVariants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <span>{children}</span>
        </motion.h4>
      );

    case 5:
      return (
        <motion.h5
          className={styles.header}
          variants={headerVariants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <span>{children}</span>
        </motion.h5>
      );

    default:
      return (
        <motion.h2
          className={styles.header}
          variants={headerVariants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <span>{children}</span>
        </motion.h2>
      );
  }
};

const CustomHeaderRenderer = ({ data }) => {
  let content = null;

  if (typeof data === 'string') content = data;
  else if (typeof data === 'object' && data.text && typeof data.text === 'string')
    content = data.text;

  return content ? <LevelHeader level={data.level}>{ReactHtmlParser(content)}</LevelHeader> : '';
};

const CustomParagraphRenderer = ({ data }) => {
  let content = null;

  if (typeof data === 'string') content = data;
  else if (typeof data === 'object' && data.text && typeof data.text === 'string')
    content = data.text;

  return content ? (
    <motion.p
      initial={{
        opacity: 0,
        y: '15%',
      }}
      animate={{
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, delay: 1 },
      }}
      exit={{
        opacity: 0,
        y: '-15%',
        transition: { duration: 0.3 },
      }}
      className={styles.paragraph}
    >
      {ReactHtmlParser(content)}
    </motion.p>
  ) : (
    ''
  );
};

const CustomListRenderer = ({ data }) => {
  if (data.items && data.items.length > 0) {
    let Comp = motion.ul;
    if (data.style === 'ordered') {
      Comp = motion.ol;
    }
    return (
      <Comp
        initial={{
          opacity: 0,
          y: '15%',
        }}
        animate={{
          opacity: 1,
          y: 0,
          transition: { duration: 0.8, delay: 1 },
        }}
        exit={{
          opacity: 0,
          y: '-15%',
          transition: { duration: 0.3 },
        }}
        className={styles.list}
      >
        {data.items.map((i, k) => (
          <li key={k}>{ReactHtmlParser(i.content || i)}</li>
        ))}
      </Comp>
    );
  }
  return null;
};

const EditorOutput = ({ animation = true, ...props }) => {
  // return <Output {...props}></Output>;

  const renderers = {
    header: CustomHeaderRenderer,
  };

  if (animation) {
    renderers.paragraph = CustomParagraphRenderer;
    renderers.list = CustomListRenderer;
  }

  const classes = [styles.wrapper];
  if (props.className) {
    classes.push(props.className);
  }

  return (
    <div className={classes.join(' ')}>
      <Output {...props} config={config} renderers={renderers} />
    </div>
  );
};

export default EditorOutput;
